import { OptionallyVisible } from 'components';
import { useTranslation } from 'react-i18next';

import { DataTableCellProps, TableCell } from 'components/dataTable';
import { Badge } from 'components/elements/badge/badge';
import { BadgeType } from 'components/elements/badge/types';

import { LABELS } from '../payouts/keys';

export const IsMainCell = ({ row, column }: DataTableCellProps) => {
  const { t } = useTranslation();
  const isMain = row[column.id] === true;
  return (
    <TableCell data-column={column.id}>
      <OptionallyVisible visible={isMain}>
        <Badge type={BadgeType.Success}>{t(LABELS.STATUSES.ACTIVE)}</Badge>
      </OptionallyVisible>
    </TableCell>
  );
};
